import { useEffect, useState } from "react";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ISubAccountData } from "@/store/SubAccountStore";
import { Button } from "@renderbus/ui";
import styled from "styled-components";

export function ChildPermission(row: ISubAccountData) {
  const t = getTranslateNsT("center");
  const [permission, setPermission] = useState([]);
  const SHOW_COUNT = 3;
  const [showMore, setShowMore] = useState(false);
  useEffect(() => {
    const names = {
      shareMainCapital: t("user_com_childManage_privilege_property"),
      subDeleteTask: t("user_com_childManage_privilege_del_task"),
      subDeleteCapital: t("user_com_childManage_privilege_del_assets"),
      useMainBalance: t("user_com_childManage_privilege_use_balance"),
      hideBalance: t("user_com_childManage_privilege_hide_balance"),
      hideJobCharge: t("user_com_childManage_privilege_hide_job_charge"),
      subFullSpeed: t("user_com_childManage_privilege_sub_full_speed"),
      groupTaskLevelView: t(
        "user_com_private_label_enable_adjust_check_task_level"
      ),
      groupTaskLevel: t("user_com_private_label_enable_adjust_edit_task_level"),
      inheritMainSoftSet: t(
        "user_com_private_label_enable_adjust_soft_setting"
      ),
      inheritMainConsumptionBillSet: t(
        "user_com_private_label_enable_adjust_consumption_bill"
      ),
      inheritMainRenderingJobSet: t(
        "user_com_private_label_enable_adjust_edit_render_task"
      ),
      inheritMainRenderingJobSetView: t(
        "user_com_private_label_enable_adjust_check_render_task"
      ),
    };
    const ret: any = [];
    Object.keys(names).forEach((v) => {
      if (row[v as keyof ISubAccountData]) {
        ret.push(<span key={v}>{names[v as keyof typeof names]}</span>);
      }
    });
    setPermission(ret);
    setShowMore(ret.length <= SHOW_COUNT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  return (
    <PermissionTextWrapper>
      {permission?.slice(0, SHOW_COUNT)}
      {showMore && permission?.slice(SHOW_COUNT)}
      {!showMore && (
        <MoreButton type="text" onClick={() => setShowMore(true)}>
          {t("user_com_private_sub_privilege_more")}
        </MoreButton>
      )}
    </PermissionTextWrapper>
  );
}

const MoreButton = styled(Button)`
  width: min-content;
  padding: 0;
  color: rgb(19, 203, 117) !important;
  &:hover {
    color: rgb(19, 203, 117) !important;
  }
`;

const PermissionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
`;
